import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CiscoUiModule } from '../cisco-ui/cisco-ui.module';

import {
  MatButtonModule,
  MatIconModule,
  MatMenuModule,
} from '@angular/material';

import { UtilsService } from './utils.service';
import { OverlayComponent } from './overlay/overlay.component';
import { ProfileImageComponent } from './profile-image/profile-image.component';
import { RecursiveDropdownMenuComponent } from './recursive-dropdown-menu/recursive-dropdown-menu.component';

@NgModule({
  imports: [
    CommonModule,  

    CiscoUiModule,

    MatButtonModule,
    MatIconModule,
    MatMenuModule, 
  ],
  declarations: [
    OverlayComponent,
    ProfileImageComponent,
    RecursiveDropdownMenuComponent,
  ],
  exports: [    
    MatButtonModule,
    MatIconModule,
    MatMenuModule, 
    
    OverlayComponent,
    ProfileImageComponent,
    RecursiveDropdownMenuComponent,
  ],
  providers: [
    UtilsService,
  ]
})
export class UtilsModule { }
